export default "__VITE_ASSET__myqmMz6O__"